import $ from 'jquery'
import { closeModal } from '@/function/function.js';
import ExcelModal from '@/views/parametres/import-excel-modal'
import store_analyse from '@/store/mods/analyses/analyse'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import listesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

export default {
    name: 'liste-analyse',
    components: {
        ExcelModal
    },
    props: [],
    data () {
        return {
            user_role: '',           //  Role d'un utilisateur
            // fields: [ {key:'nom',label: 'Noms'}, {key:'prix',label: 'Prix'},'actions'],
            fields: [ 
                {key:'nom', label: 'Analyse'}, {key:'technique_utilisee', label: 'Technique utilisée'}, 
                {key:'prix', label: 'Prix'}, 'actions'
            ],
            print_fields: [
                {key:'nom', label: 'Analyse'}, {key:'technique_utilisee', label: 'Technique utilisée'}, 
                {key:'prix', label: 'Prix'}
            ],
            // fields: [{ key: 'index', label: 'N°' }, 'abreviation', 'nom','categorie',{key:'prix',label:' Prix'},'actions'],
            laboFields: [{ key: 'index', label: 'N°' }, 'abreviation', 'nom', 'actions'],

            selectedAnalyse: null,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Catégorie': 'categorie',
                'Libellé': 'libelle',
                'Abreviation': 'abreviation',
                'Prix': 'prix',
                'Technique utilisée': 'technique_utilisee'
            },

            json_data: [],
            export_filename: 'Liste_Analyses.xls',
            can_print: false,
            liste_distinct_analyses: [],

            // Catégories { id, categorie, nombre_analyses } et une liste paginée côté serveur par catégorie (indexée par id)
            categories: [],
            analyses_par_categorie: {},
            categories_erreur: false,

            // Liste complète par catégorie, chargée uniquement pour l'impression
            analyses_by_category: [],
            anl_loading: true,
            anl_empty: false,

            selected_category: {
                id: 0,
                categorie: 'Toutes les catégories'
            },
            vm_state: open_menu_state,
            
            anl_loading_percentage: 0,
            can_view_percentage: false,
            anl_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        // Options du filtre de catégorie (sans doublon : recalculées à chaque rechargement des catégories)
        category_filter() {
            const select_all = {
                id: 0,
                categorie: 'Toutes les catégories'
            }
            return [select_all].concat(this.categories.map(categorie => ({
                id: categorie.id,
                categorie: categorie.categorie
            })))
        },

        // Un bloc par catégorie : la catégorie et sa liste paginée
        blocs_categories() {
            return this.categories
                .filter(categorie => this.analyses_par_categorie[categorie.id])
                .map(categorie => ({
                    categorie: categorie,
                    liste: this.analyses_par_categorie[categorie.id]
                }))
        },

        // Nombre total d'analyses (toutes catégories) : fin de l'attente après un import
        total_analyses() {
            return this.categories.reduce((total, categorie) => total + (parseInt(categorie.nombre_analyses) || 0), 0)
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    beforeDestroy() {
        if (this.anl_refresh_timeout_id) {
            clearTimeout(this.anl_refresh_timeout_id)
            this.anl_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted () {
        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }
        this.getAnalyseByCategorie()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_des_analyses_'+tmpstamp

        // this.selectDistinctAnalyse()
    },
    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListAnalyse'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.anl_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.anl_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.anl_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeAnalyse() {
            this.anl_loading = true
            this.can_view_percentage = true
            if (this.anl_refresh_timeout_id) {
                clearTimeout(this.anl_refresh_timeout_id)
                this.anl_refresh_timeout_id = null
            }

            if (this.total_analyses > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getAnalyseByCategorie()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getAnalyseByCategorie()
            this.anl_refresh_timeout_id = setTimeout(() => {
                this.refreshListeAnalyse()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeAnalyse()
        },

        /**
         * Catégories (avec leur nombre d'analyses), puis la page courante de chaque catégorie.
         * La page et la recherche déjà saisies d'une catégorie sont conservées au rechargement.
         */
        getAnalyseByCategorie() {
            this.categories_erreur = false

            return listesPaginees.categoriesAnalyses().then((categories) => {
                this.categories = categories || []

                const listes = {}
                this.categories.forEach(categorie => {
                    listes[categorie.id] = this.analyses_par_categorie[categorie.id] || nouvelleListe()
                })
                this.analyses_par_categorie = listes
                this.anl_empty = this.categories.length == 0

                return Promise.all(this.categories.map(categorie => this.chargerAnalyses(categorie.id)))
            }).catch(() => {
                this.categories_erreur = true
            }).finally(() => {
                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.anl_loading = false
                    }
                } else {
                    this.anl_loading = false
                }
            })
        },

        /**
         * Page courante des analyses d'une catégorie (pagination et recherche côté serveur)
         * @param {*} categorie_id
         */
        chargerAnalyses(categorie_id) {
            const liste = this.analyses_par_categorie[categorie_id]
            if (!liste) {
                return Promise.resolve()
            }
            return chargerPage(liste, params => listesPaginees.analysesCategorie(categorie_id, params))
        },

        /**
         * Recherche dans une catégorie après la saisie (retour à la page 1)
         * @param {*} categorie_id
         */
        rechercherAnalyses(categorie_id) {
            const liste = this.analyses_par_categorie[categorie_id]
            if (liste) {
                rechercherDiffere(liste, () => this.chargerAnalyses(categorie_id))
            }
        },

        // Filtre de catégorie : tous les blocs si aucune catégorie (ou « Toutes les catégories ») n'est choisie
        categorieVisible(categorie) {
            const category_id = this.selected_category?.id
            return !(category_id > 0) || category_id == categorie.id
        },

        deleteAnalyse: function (id){
            const categorie_id = this.selectedAnalyse ? this.selectedAnalyse.categorie_id : null

            this.$store.dispatch('deleteAnalyse',id).then(() => {
                this.$refs.closeDeleteAnalyseBtn.click();
                this.deletionAnalyseSuccess()

                // Recharge seulement la page courante de la catégorie concernée
                if (categorie_id && this.analyses_par_categorie[categorie_id]) {
                    this.chargerAnalyses(categorie_id)
                } else {
                    this.getAnalyseByCategorie()
                }
            })
        },

        modalDeleteAnalyse: function(analyse){
            this.selectedAnalyse = analyse
        },

        deletionAnalyseSuccess: function(){
            this.$toasted.show('L\'analyse a été supprimée avec succès',{
                duration: 5000,
                action:[
                    {
                        text:'X',
                        onClick:(e,toastObject)=>{
                            toastObject.goAway(0);
                        }
                    }
                ],
                theme:'toasted-primary',
                type:'success'
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Analyses_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        /**
         * Liste complète des analyses par catégorie (impression, export)
         */
        chargerAnalysesCompletes() {
            return store_analyse.getListeAnalyseByCategory().then((cat_analyses) => {
                return cat_analyses || []
            })
        },

        /**
         * Export Excel : la liste complète est chargée au clic
         * (prop `fetch` de export-excel, appelée après before-generate)
         */
        fetchExportAnalyses() {
            return this.chargerAnalysesCompletes().then((cat_analyses) => {
                const lignes = []
                cat_analyses.forEach(cat => {
                    (cat.analyses || []).forEach(anl => {
                        lignes.push({
                            'categorie': cat.categorie,
                            'libelle' : anl.analyse,
                            'abreviation': anl.abreviation,
                            'prix' : (anl.prix > 0)?anl.prix:'',
                            'technique_utilisee': (anl.technique_utilisee != null)?anl.technique_utilisee:''
                        })
                    });
                });

                if (lignes.length == 0) {
                    // Rien à exporter : export-excel s'arrête sans appeler before-finish
                    this.is_exporting = false
                }
                return lignes
            }).catch(() => {
                this.is_exporting = false
                this.errorToast("Impossible de préparer l'export. Merci de réessayer.")
                return []
            })
        },

        printListeAnalyse() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            // Impression de toutes les catégories : liste complète chargée au clic
            this.chargerAnalysesCompletes().then((cat_analyses) => {
                this.analyses_by_category = cat_analyses
                this.can_print = true
                setTimeout(() => {
                    window.print()

                    this.can_print = false
                    this.analyses_by_category = []
                    this.is_printing = false
                }, 500);
            }).catch(() => {
                this.is_printing = false
                this.errorToast("Impossible de charger la liste à imprimer. Merci de réessayer.")
            })
        },

        selectDistinctAnalyse() {
            this.json_data = []
            store_analyse.getDistinctAnalyse().then((response) => {
                this.liste_distinct_analyses = response

                if (this.liste_distinct_analyses.length > 0) {
                    this.liste_distinct_analyses.forEach(analyse => {
                        this.json_data.push({
                            'nom_analyse' : analyse.nom_analyse,
                            'categorie': analyse.categorie
                        })
                    });
                }
            })
        },

        routeTo(route) {
            this.$router.push({ name: route })
        },
    }
}